/**
 * @file Waldo "Powered by" logo.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../util/assets';

const propTypes = {
  className: PropTypes.string,
};

const LogoPoweredBy = ({ className }) => {
  const classes = classNames({
    'waldo-poweredby-logo': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <img
        src={getAsset('/waldo-icon.svg')}
        alt="Waldo logo"
        className="waldo-poweredby-icon"
      />
      <span className="waldo-poweredby-logo-text">
        powered by
        <span className="waldo-poweredby-logo-brand">waldo</span>
      </span>
    </div>
  );
};

LogoPoweredBy.propTypes = propTypes;

export default LogoPoweredBy;
